import { render, staticRenderFns } from "./FlexiquoteModuleView.vue?vue&type=template&id=159cc719&scoped=true"
import script from "./FlexiquoteModuleView.vue?vue&type=script&lang=js"
export * from "./FlexiquoteModuleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159cc719",
  null
  
)

export default component.exports